import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import VideoThumbnailCard from "../VideoThumbnailCard/VideoThumbnailCard";
import { getVideoDetail, increaseViewCount, relatedVideos } from "../../utils/api-Request";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { videoPath } from "../../server";
import { jwt } from "../../server";
import Banner from "./../../assets/images/SimulanisLogo.png";
import { Link } from "react-router-dom";

const DetailPage = () => {
  const [videoData, setVideoData] = useState([]);
  const [relatedVideo, setRelatedVideo] = useState([]);
  const [lastIndexId, setLastIndexId] = useState("");
  const [youtubeToggle, setYoutubeToggle] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [copied, setCopied] = useState(false);
  const lastId = window.location.href.split("/");
  let lastIndexNumber = lastId[lastId.length - 1];

  const handleCopy = () => {
    setTimeout(() => setCopied(true), 100);
    navigator.clipboard.writeText(window.location.href);
    setTimeout(() => setCopied(false), 2500);
  };
  const _getVideoDetails = async (id) => {
    try {
      let data = {
        id,
      };
      let res = await getVideoDetail(data);
      setVideoData(res.data.data);
    } catch (error) {}
  };

  const _increaseViewCount = async (id) => {
    try {
      let res = await increaseViewCount(id);
    } catch (error) {}
  };

  const _getRelatedVideos = async (id) => {
    try {
      let res = await relatedVideos(id);
      if (res) {
        setRelatedVideo(res?.data?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    _getVideoDetails(lastIndexNumber);
    if (jwt) {
      setLastIndexId(lastIndexNumber);
      _increaseViewCount(lastIndexNumber);
      _getRelatedVideos(lastIndexNumber);
    }
  }, [lastIndexNumber]);

  // useEffect(() => {
  //   const handleContextMenu = (e) => e.preventDefault();
  //   const handleKeyDown = (e) => {
  //     if (
  //       e.keyCode === 123 ||
  //       (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
  //       (e.ctrlKey && e.key === "u")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);
  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  const getUrl = (youTubeUrl, video_Path) => {
    if (!video_Path && !youTubeUrl) return "null";
    if (video_Path) {
      return youTubeUrl && youtubeToggle ? youTubeUrl : `${videoPath}${video_Path}`;
    } else {
      return youTubeUrl || null;
    }
  };
  const videoUrl = getUrl(videoData?.youtubeURL, videoData?.video_path);
  return (
    <>
      <section className="detailpage">
        <div className="container-xxl">
          <div className="row">
            <div className={jwt ? "col-md-8" : "col-md-12 videfullscreen"}>
              <div className="relative w-full h-full">
                {isPlaying && (
                  <img
                    src={Banner}
                    alt="Watermark"
                    className="absolute top-4 right-4 z-20 w-20 opacity-80 pointer-events-none"
                  />
                )}

                <ReactPlayer
                  className="react-player fixed-bottom"
                  url={videoUrl}
                  width="100%"
                  height="100%"
                  playing={isPlaying}
                  controls={true}
                  onClickPreview={() => setIsPlaying(true)}
                  config={{
                    file: {
                      attributes: {
                        controlsList: "nodownload",
                        width: "100%",
                        height: "100%",
                      },
                      tracks: [
                        {
                          kind: "captions",
                          // src: `${videoPath}${videoData?.video_path}`,
                          srcLang: "en",
                          default: true,
                        },
                      ],
                    },
                  }}
                />
              </div>
              <h4 className="d-flex align-items-center mt-2">
                {videoData?.title}

                {videoData?.youtubeURL && (
                  <>
                    <p
                      style={{ cursor: "pointer", color: "#ca373c" }}
                      onClick={() => setYoutubeToggle(!youtubeToggle)}
                      className="ms-3 mb-0"
                    >
                      <YouTubeIcon />
                    </p>
                  </>
                )}
              </h4>
              {videoData?.youtubeURL && (
                <div
                  className="linkparent 
              "
                >
                  <p>{window.location.href}</p>{" "}
                  <div className="share-btn-parent">
                    <span className="share-btn">
                      <span className={copied ? "copynow done" : "copynow"} onClick={handleCopy}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-link me-1"
                          viewBox="0 0 16 16"
                        >
                          <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
                          <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
                        </svg>
                      </span>
                    </span>
                  </div>
                </div>
              )}
              <p> {videoData?.description}</p>
            </div>

            {jwt && (
              <div className="col-md-4">
                <div className="siggestedvideo ps-4">
                  <h1 className="mb-3">Related Videos</h1>
                  <ul className="relatedVideo">
                    <li>
                      <div>
                        {relatedVideo.map((e, i) => {
                          return (
                            <div key={i}>
                              <VideoThumbnailCard data={e} />
                            </div>
                          );
                        })}
                        {/* <VideoThumbnailCard title="12424424" createdAt="2023-04-28 08:28:17" description="345454lk6j45lk6j4l5kj645lk64l56"/> */}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default DetailPage;
